import * as React from 'react';
import { useI18n } from '@oneaudi/i18n-context';
import { messages } from '../../i18n/messages';
import { TextButton } from '@oneaudi/unified-web-components';
import styled from 'styled-components';
const ExpandableButtonContainer = styled.div `
  display: flex;
  justify-content: center;
  order: 1;
`;
export const ExpandableButtonUnified = ({ isExpanded, onExpandHandler, i18n, }) => {
    const lessLabel = i18n ? i18n.lessLabel : useI18n(messages.expandable.button.lessLabel);
    const moreLabel = i18n ? i18n.moreLabel : useI18n(messages.expandable.button.moreLabel);
    return (React.createElement(ExpandableButtonContainer, null,
        React.createElement(TextButton, { variant: "tertiary", icon: isExpanded ? 'remove-circle' : 'add-circle', iconPosition: "leading", size: "md", onClick: onExpandHandler, "data-testid": "expandableBtn" }, isExpanded ? lessLabel : moreLabel)));
};
